import { Component, computed, HostBinding, input, ChangeDetectionStrategy } from '@angular/core';

export interface DonutValue {
  value: number | null;
  color: string;
}

@Component({
  selector: 'donut',

  templateUrl: './donut.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './donut.component.scss',
})
export class DonutComponent {
  public values = input<DonutValue[]>([]);
  public globalValue = input<string | number | null>(null);

  private _cumulateValues = computed(() =>
    this.values().reduce((acc, v, index) => {
      const lastValue = acc[index - 1]?.value ?? 0;
      return [...acc, { ...v, value: v.value + lastValue }];
    }, [])
  );

  private _conicGradient = computed(() => this.generateConicGradient(this._cumulateValues()));

  @HostBinding('style.background') get gradient() {
    return this._conicGradient();
  }

  /* Center text display by peseudo element before in css */
  @HostBinding('attr.data-global-value') get value() {
    if (this.globalValue() === null) {
      return '';
    }
    return this.globalValue();
  }

  public generateConicGradient(values: DonutValue[]): string {
    let gradient = '';
    let cumulativePercent = 0;
    for (let index = 0; index < values.length; index++) {
      const element = values[index];
      const isLast = index === values.length - 1;
      gradient += `${element.color} ${cumulativePercent}% ${element.value}%${isLast ? '' : ', '}`;
      cumulativePercent = element.value;
    }

    if (values[values.length - 1].value < 100) {
      gradient += `, var(--background-elevated) ${cumulativePercent}% 100%`;
    }
    return `conic-gradient(${gradient})`;
  }
}
